import { HEIGHT_WITH_NAV_AND_FOOTER } from "components/ProjectSpecificComponents/Constants/GLOBAL_CONSTANTS"
import React from "react"
import { CSSProperties } from "styled-components"
import HyperDiv from "../Elements/HyperDiv/HyperDiv"
import useScreenType from "../Hooks/useScreenType"
import SideBar from "./SideBar"
interface Props {
	leftPanel: JSX.Element
	tabletSidebar: JSX.Element
	children: JSX.Element
	phoneChildren?: JSX.Element
	rightPanel?: JSX.Element // Right panel is optional for some views
}

/**
 * Conditionally renders page layout based on screen width
 * Content is made from three rows : LEFT | MAIN | RIGHT
 * Right pane is optional.
 */
export default function ResponsiveLayout({
	leftPanel,
	tabletSidebar,
	rightPanel,
	children,
	phoneChildren,
}: Props) {
	const { screenType } = useScreenType()

	const flexBoxStyle: CSSProperties = {
		maxWidth: "100%",
		width: "100vw",
		height: HEIGHT_WITH_NAV_AND_FOOTER, // Page height minus nav bar
		maxHeight: "100vh",
		overflow: "hidden",
	}

	//Shows all panels full size with full detail
	if (screenType === "3-cols")
		return (
			<HyperDiv spacedEvenly style={{ ...flexBoxStyle }}>
				<HyperDiv style={{ maxWidth: "2000px" }} width="100%" direction="row">
					<SideBar type="left">{leftPanel}</SideBar>
					{children}
					{rightPanel && <SideBar type="right">{rightPanel}</SideBar>}
				</HyperDiv>
			</HyperDiv>
		)

	//Left panel has less details
	if (screenType === "2-cols")
		return (
			<HyperDiv direction="row" spacedEvenly style={flexBoxStyle}>
				<SideBar type="left">{tabletSidebar}</SideBar>
				{children}
				{rightPanel && <SideBar type="right">{rightPanel}</SideBar>}
			</HyperDiv>
		)

	//Left panel has less details, right panel is removed
	if (screenType === "1-cols")
		return (
			<HyperDiv direction="row" stretchedAcross spacedEvenly style={flexBoxStyle}>
				<SideBar type="left">{tabletSidebar}</SideBar>
				{children}
			</HyperDiv>
		)

	//Shows only content
	return <>{phoneChildren ?? children}</>
}
